<template>
  <div class="about">
    <iframe class="pdfcss" :src="`https://wthedu.51suiyixue.com/PDF/web/viewer.html?file=${url}`" frameborder="0"></iframe>
  </div>
</template>
<script>
 import {
    api
  } from '../assets/api/axios'
export default {
  data() {
    return {
      // url:'https://wutonghua-oss.oss-cn-qingdao.aliyuncs.com/crm-develop/null/1872811014723303310.pdf'
      url:""
    }
  },
  created() {
      this.watchOnline()
  },
  methods: {
    async watchOnline() {
        let res = await api.post('/front/teamaterial/getFileDetail', {
          fileId: this.$route.query.rid,
        })
        if (res.code == 2000) {
          this.$message.warning('没有在线文档')
        } else {
         this.url = res.data.filePath
        }
      },
  }
}
</script>
<style>
html,body{
  width: 100%;
}
#app{
  width: 100%;
  min-width: 100%;
}
</style>

<style scoped>
  .about{
    width: 100%;
    height: 100vh;
  }
  .pdfcss{
    width: 100%;
    height: 100%;
  }
</style>
